import Image from 'next/image'
import { useTranslation } from 'hooks/useTranslation'
import ownerFeedingPug from '../../../../../../../../public/assets/product-v2/freeze-dried-box/owner-feeding-pug-fd.webp'
import {
  WhyFreezeDriedRawRoot,
  WhyFreezeDriedRawContainer,
  Headline,
  ContentRow,
  ImageColumn,
  BenefitsList,
  BenefitItem,
  BenefitLabel,
  BenefitDescription,
} from './WhyFreezeDriedRaw.styles'

const benefits = [1, 2, 3, 4] as const

export const WhyFreezeDriedRaw = () => {
  const { t } = useTranslation()

  return (
    <WhyFreezeDriedRawRoot>
      <WhyFreezeDriedRawContainer>
        <Headline>{t('products-v2:freeze-dried-raw-nuggets.why-freeze-dried-raw.headline')}</Headline>
        <ContentRow>
          <ImageColumn>
            <Image
              layout="fill"
              objectFit="cover"
              src={ownerFeedingPug}
              alt={t('products-v2:freeze-dried-raw-nuggets.why-freeze-dried-raw.image')}
            />
          </ImageColumn>
          <BenefitsList>
            {benefits.map((n) => (
              <BenefitItem key={n}>
                <BenefitLabel weight="semiBold">
                  {t(`products-v2:freeze-dried-raw-nuggets.why-freeze-dried-raw.benefit-${n}-label`)}
                </BenefitLabel>
                <BenefitDescription>
                  {t(`products-v2:freeze-dried-raw-nuggets.why-freeze-dried-raw.benefit-${n}-description`)}
                </BenefitDescription>
              </BenefitItem>
            ))}
          </BenefitsList>
        </ContentRow>
      </WhyFreezeDriedRawContainer>
    </WhyFreezeDriedRawRoot>
  )
}

WhyFreezeDriedRaw.displayName = 'WhyFreezeDriedRaw'
